import React, { Component } from 'react';
import Api from './Api';
const { $ } = window;

class PlayerItem extends Component{
	constructor(props) {
		super(props);
		this.state = { }
	}
	componentDidMount() {   		
	    $('.magnific-popup').magnificPopup({
	      type: 'image',
	      mainClass: 'mfp-zoom-in',
	      closeOnContentClick: true,
	      midClick: true,
	      zoom: {
	        enabled: true,
	        duration: 300
	      }
	    });
	}
		

	render() {

		return (  
		   
			<div  className="col-sm-6 item" id={this.props.player.id}>
				<h3 className="title">{this.props.player.title}</h3>
				<p className="name">{this.props.player.name}, {this.props.player.age} años</p>
				<a className="magnific-popup image_holder" href={Api.url('uploads/')+ this.props.player.filename}  >
					<img src={Api.url('uploads/thumb_')+ this.props.player.filename}  alt={this.props.player.title} className="img-rounded img-responsive" />
				</a>
			

				<div className="btn-actions">
					<iframe src={"https://www.facebook.com/plugins/like.php?href="+encodeURIComponent(this.props.urlShare)+"&locale=es_ES&width=220&layout=button_count&action=like&size=large&show_faces=false&share=true&height=46"} width="220" height="46" style={{border:"none",overflow:"hidden"}} scrolling="no" allowTransparency="true"></iframe>
				</div>
			</div>			
		)
	}

}
export default class PlayerList extends Component {

	constructor(props) {
		super(props);
		this.state = { }

		
		//this.toggleDialog = this.toggleDialog.bind(this);
	}
	

	render() {

		return (
		  
		    <div className="row items">
		    {
		      this.props.items.map(function(player, key) {
		        let urlShare = Api.url() + 'share.php?id=' + player.id;
		        return (
		        	<PlayerItem key={key} player={player} urlShare={urlShare}/>			
		        ) 
		      
		      }, this)
		    }
			</div>
		  
		)
	}
}



// WEBPACK FOOTER //
// ./src/PlayerList.js